import { roomActions } from "../actions/roomActions";

const initState={
    isUserInRoom:false,
    isUserRoomCreator:false,
    roomDetails:null,
    activeRooms:[],
    localStreams:null,
    audioOnly:false,
    screenSharingStream:null,
    isScreenSharingActive:false,
    servers:[],
    selectedServer:null,
    selectedChannel:null,
    voiceRoomId:null,
    voiceParticipants:[],
    serverInvitations:[],
}
const reducer=(state=initState,action)=>{
switch(action.type){
    case roomActions.OPEN_ROOM:
        return  {
            ...state,isUserInRoom:action.isUserInRoom,
            isUserRoomCreator:action.isUserRoomCreator
        }
    case roomActions.SET_SERVERS:
        return {
            ...state,
            servers: action.servers,
        };
    case roomActions.ADD_SERVER:
        return {
            ...state,
            servers: [...state.servers, action.server],
            selectedServer: action.server,
            selectedChannel: action.server.channels.find((channel) => channel.type === "TEXT") || null,
        };
    case roomActions.SET_SELECTED_SERVER:
        return {
            ...state,
            selectedServer: action.server,
            selectedChannel: action.server?.channels?.find((channel) => channel.type === "TEXT") || null,
            voiceRoomId: null,
            voiceParticipants: [],
        };
    case roomActions.SET_SELECTED_CHANNEL:
        return {
            ...state,
            selectedChannel: action.channel,
        };
    case roomActions.SET_VOICE_PARTICIPANTS:
        return {
            ...state,
            voiceRoomId: action.roomId || null,
            voiceParticipants: action.participants,
        };
    case roomActions.SET_SERVER_INVITATIONS:
        return {
            ...state,
            serverInvitations: action.invitations,
        };
    case roomActions.REMOVE_SERVER_INVITATION:
        return {
            ...state,
            serverInvitations: state.serverInvitations.filter(
                (invitation) => invitation._id !== action.invitationId
            ),
        };
    case roomActions.UPDATE_SERVER:
        return {
            ...state,
            servers: state.servers.map((server) => server.id === action.server.id ? action.server : server),
            selectedServer: state.selectedServer?.id === action.server.id ? action.server : state.selectedServer,
            selectedChannel: action.server.channels.find((channel) => channel.id === state.selectedChannel?.id) || state.selectedChannel,
        };
    default:
        return state;
}
};
export default reducer;
